import { ThmRouteObject } from 'src/common/interfaces';
export const pt1Routes: ThmRouteObject[] = [{
  path: '/',
  async lazy() {
    const {
      PentestSimSection
    } = await import('src/features/certifications/exam/section/inprogress/pentest-sim');
    return {
      Component: PentestSimSection
    };
  },
  children: [{
    path: 'dashboard',
    async lazy() {
      const {
        PentestDashboard
      } = await import('src/features/certifications/exam/section/inprogress/pentest-sim/components/pentest-dashboard');
      return {
        Component: PentestDashboard
      };
    }
  }, {
    path: 'report',
    async lazy() {
      const {
        PentestReports
      } = await import('src/features/certifications/exam/section/inprogress/pentest-sim/components/pentest-reports');
      return {
        Component: PentestReports
      };
    }
  }, {
    path: 'attackbox',
    async lazy() {
      const {
        PentestAttackBox
      } = await import('src/features/certifications/exam/section/inprogress/pentest-sim/components/pentest-attackbox');
      return {
        Component: PentestAttackBox
      };
    }
  }, {
    path: 'pass-criteria',
    async lazy() {
      const {
        PentestPassCriteria
      } = await import('src/features/certifications/exam/section/inprogress/pentest-sim/components/pentest-pass-criteria');
      return {
        Component: PentestPassCriteria
      };
    }
  }, {
    path: 'help',
    async lazy() {
      const {
        PentestHelp
      } = await import('src/features/certifications/exam/section/inprogress/pentest-sim/components/pentest-help');
      return {
        Component: PentestHelp
      };
    }
  }]
}];